(() => {
  'use strict';
  if (window.hlPredictiveSearchLoaded) return;
  window.hlPredictiveSearchLoaded = true;

  function initialize(root) {
    root.querySelectorAll('[data-hl-search]').forEach((form) => {
      if (form.dataset.hlInitialized) return;
      form.dataset.hlInitialized = 'true';
      const input = form.querySelector('[name="q"]');
      const panel = form.querySelector('[data-hl-panel]');
      const results = form.querySelector('[data-hl-results]');
      const status = form.querySelector('[data-hl-status]');
      const backdrop = form.querySelector('[data-hl-backdrop]');
      const closeButton = form.querySelector('[data-hl-close]');
      const cache = new Map();
      let timer, controller, revision = 0, active = -1;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-haspopup', 'listbox');

      function options() { return Array.from(results.querySelectorAll('[data-hl-option]')); }
      function select(index) {
        active = index;
        options().forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
        const option = options()[index];
        if (option) {
          input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({block: 'nearest'});
        } else input.removeAttribute('aria-activedescendant');
      }
      function cancel() {
        clearTimeout(timer);
        revision++;
        if (controller) controller.abort();
        results.setAttribute('aria-busy', 'false');
      }
      function close() {
        cancel();
        form.classList.remove('hl-search-open');
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        select(-1);
        status.textContent = '';
      }
      function alignPanel() {
        panel.style.marginLeft = '0px';
      }
      function render(markup) {
        results.innerHTML = markup;
        const list = results.querySelector('[role="listbox"]');
        if (!list) { close(); return; }
        list.id = results.id + '-list';
        input.setAttribute('aria-controls', list.id);
        options().forEach((option, i) => { option.id = results.id + '-option-' + i; });
        select(-1);
        panel.hidden = false;
        form.classList.add('hl-search-open');
        alignPanel();
        input.setAttribute('aria-expanded', 'true');
        results.setAttribute('aria-busy', 'false');
        status.textContent = results.querySelector('[data-hl-response]').dataset.announcement;
      }
      async function search(term, requestRevision) {
        if (cache.has(term)) { render(cache.get(term)); return; }
        controller = new AbortController();
        status.textContent = form.dataset.loading;
        results.setAttribute('aria-busy', 'true');
        const params = new URLSearchParams({q: term, section_id: 'hl-predictive-search', 'resources[type]': 'query,product,page,collection', 'resources[limit]': '9', 'resources[limit_scope]': 'each'});
        try {
          const response = await fetch(form.dataset.endpoint + '?' + params, {signal: controller.signal});
          if (!response.ok) throw new Error('Predictive search unavailable');
          const markup = await response.text();
          if (requestRevision !== revision || document.activeElement !== input) return;
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const content = parsed.querySelector('[data-hl-response]');
          if (!content) throw new Error('Missing predictive search section');
          if (cache.size >= 20) cache.delete(cache.keys().next().value);
          cache.set(term, content.outerHTML);
          render(content.outerHTML);
        } catch (error) {
          if (requestRevision === revision) close();
        }
      }
      function schedule(event) {
        close();
        form.classList.add('hl-search-open');
        if (event && event.isComposing) return;
        const term = input.value.trim();
        if (term.length < 2) return;
        const requestRevision = revision;
        timer = setTimeout(() => search(term, requestRevision), 250);
      }
      input.addEventListener('input', schedule);
      input.addEventListener('compositionend', schedule);
      input.addEventListener('focus', schedule);
      input.addEventListener('keydown', (event) => {
        if (event.isComposing) return;
        if (event.key === 'Escape') { if (!panel.hidden) event.preventDefault(); close(); return; }
        const items = options();
        if (panel.hidden || !items.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          select(event.key === 'ArrowDown' ? (active + 1) % items.length : (active < 0 ? items.length - 1 : (active - 1 + items.length) % items.length));
        } else if (event.key === 'Enter' && active >= 0) {
          event.preventDefault();
          items[active].querySelector('a').click();
        }
      });
      form.addEventListener('focusout', (event) => { if (!form.contains(event.relatedTarget)) close(); });
      panel.addEventListener('mousedown', (event) => { if (event.target.closest('a')) event.preventDefault(); });
      document.addEventListener('pointerdown', (event) => { if (!form.contains(event.target)) close(); });
      form.addEventListener('submit', close);
      backdrop.addEventListener('click', close);
      closeButton.addEventListener('click', () => { input.focus(); close(); });
      window.addEventListener('resize', alignPanel);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
